import CommentToggle from './CommentToggle';
import CommentPreview from './CommentPreview';

document.querySelectorAll('.js-toggleAllComments').forEach($toggle => new CommentToggle($toggle));
document.querySelectorAll('.js-comment-preview').forEach($trigger => new CommentPreview($trigger));
